var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('v-overlay',{attrs:{"opacity":"0.98","absolute":_vm.absolute,"value":_vm.loading,"z-index":"9"}},[_c('v-progress-circular',{attrs:{"size":"70","width":"7","color":"primary","indeterminate":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }